import { fetchFromRTM, fetchFromRTMMemoized } from './index';
import * as constants from './constants';
import './typedef';

class PluginResolver {
  constructor(connection) {
    this.connection = connection;
  }

  /**
   * @typedef PluginFetchResponse
   * @property {PluginSummaryDTO} summary
   * @property {PluginManifestDTO} manifest
   * @property {[PluginEntryPointDTO]} entryPoints
   */

  /**
   * Fetches a plugin from the RTM. See
   *   [RTM Docs](https://dev-developers.smartsparrow.com/messages/author-plugin-get/)
   * @param {string} pluginId
   * @param {string} version
   * @param {string} view The context.  I.e., EDITOR
   * @returns {Promise.<PluginFetchResponse>}
   */
  authorPluginGet = async (pluginId, version, view, memoize = true) => {
    const message = {
      type: constants.RTM_AUTHOR_PLUGIN_GET,
      pluginId,
      version,
      view,
    };

    const fetchFn = memoize ? fetchFromRTMMemoized : fetchFromRTM;

    const response = await fetchFn(
      this.connection,
      message,
      constants.RTM_AUTHOR_PLUGIN_GET_OK,
      constants.RTM_AUTHOR_PLUGIN_GET_ERROR,
    );

    return response.plugin;
  }

  authorPluginList = async (pluginType) => {
    const message = {
      type: constants.RTM_AUTHOR_PLUGIN_LIST,
      pluginType,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_PLUGIN_LIST_OK,
      constants.RTM_AUTHOR_PLUGIN_LIST_ERROR,
    );

    return response.plugins;
  }

  authorEditActive = async (elementId) => {
    const message = {
      type: constants.RTM_AUTHOR_EDIT_ACTIVE,
      elementId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_EDIT_ACTIVE_OK,
      constants.RTM_AUTHOR_EDIT_ACTIVE_ERROR,
    );

    return response;
  }

  authorEditRelease = async (elementId) => {
    const message = {
      type: constants.RTM_AUTHOR_EDIT_RELEASE,
      elementId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_EDIT_RELEASE_OK,
      constants.RTM_AUTHOR_EDIT_RELEASE_ERROR,
    );

    return response;
  }
}

export default PluginResolver;
